<template>
  <div>
    <!-- サイドメニュー -->
    <v-navigation-drawer app v-model="drawer" clipped>
      <v-list dense nav flat class="pa-0 pt-2">
      </v-list>
    </v-navigation-drawer>
    <!-- ヘッダー -->
    <v-app-bar color="indigo" dark app clipped-left dense>
      <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>契約先選択</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- ユーザinfo-->
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
          v-bind="attrs"
          v-on="on"
        >
          <template v-slot:activator="{ on, attrs }">
            <!-- スマホサイズの場合は文字を表示しない -->
            <v-btn
              v-if="breakpoint"
              text
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>person</v-icon>
            </v-btn>
            <!-- PCサイズの場合は文字を表示する -->
            <v-btn
              v-else
              text width="150"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="mr-1">person</v-icon>ユーザー情報
            </v-btn>
          </template>
          <v-card class="pa-2">
            <v-container>
              <v-row justify="center" align-content="center">
                <v-card-text class="pa-1 text-center">{{ user.name }}</v-card-text>
                <v-card-text class="pa-1 text-center">{{ user.email_addr }}</v-card-text>
              </v-row>
            <v-divider></v-divider>
            <v-row justify="center" align-content="center">
              <v-card-actions>
                <v-btn
                  @click="logout"
                  class="text-capitalize" outlined
                >Logout</v-btn>
              </v-card-actions>
            </v-row>
          </v-container>
        </v-card>
      </v-menu>
      <!-- userInfo end -->
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <p class="ma-2 pa-2">閲覧したい契約先を選択してください</p>
        <div class="d-flex flex-column-reverse">
          <v-btn v-for="item in kiykskLists"
            :key="item.kiyk_cd"
            @click="setKiykCd(item.kiyk_cd)"
            class="ma-2"
            color="indigo" x-large
            dark
          >
            <v-icon class="mr-1">apartment</v-icon>
            {{item.kiyk_nm}}
          </v-btn>
        </div>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import myAxios from '../../axios/myAxios.js'
import MsgList from '../modules/MsgList'

export default {
  components: {
  },
  data () {
    return {
      dialog: false,
      sideMenuItems: [],
      kiykskLists: [],
      sesErrMsg: MsgList.MSG_SES_CANNOT_CONFIRM,
      masterKanriFlg: false,
      connectionErrMsg: MsgList.MSG_CONNETION_ERROR,
      userInfo: false,
      user: {
        user_cd: '',
        name: '',
        email_addr: '',
        kngn_typ: '',
        kiyk_cd: ''
      }
    }
  },
  created () {
    this.$store.dispatch('appSetting/fLogin')
    // ログインセッションの確認
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result

      if (!(status && result)) {
        alert(this.sesErrMsg)
        this.$router.push('/')
      }
    // eslint-disable-next-line handle-callback-err
    }).catch(err => {
      alert(this.connectionErrMsg)
      this.$router.push('/')
    })

    // ユーザinfoポップアップ用の情報を取得
    myAxios.get('/api/common/session_manager', {type: 'userinfo_popup'}).then(res => {
      const status = res.data.status
      const result = res.data.result

      if (status && result) {
        this.user.name = res.data.name
        this.user.email_addr = res.data.email_addr
        this.user.user_cd = res.data.user_cd
      }
    })
    // 表示する契約先の情報を取得する
    this.getKisksk()
  },
  methods: {
    logout: function () {
      // ポップアップ消す
      this.dialog = false
      // ログアウト処理
      this.$store.dispatch('appSetting/fLogin')
      myAxios.get('/api/common/session_manager', {type: 'logout'}).then(res => {
        const status = res.data.status
        const result = res.data.result

        if (!(status && result)) {
          // alert(this.connectionErrMsg)
        }
        this.$router.push('/')
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        alert(this.connectionErrMsg)
        this.$router.push('/')
      })
    },
    // 表示する契約先の情報を取得する
    getKisksk: function () {
      myAxios.get('/api/login/kiyksk_sntk').then(res => {
        if (res.data.Status) {
          this.kiykskLists = res.data.dict_result
        } else {
          this.kiykskLists = []
        }
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        console.log('表示する契約先の情報を取得できなかった')
        alert(this.connectionErrMsg)
        this.kiykskLists = []
      })
    },
    // 契約コードをセッションに設定する
    setKiykCd: function (tmpkiykCd) {
      myAxios.get('/api/login/kiyksk_sntk_set', {kiyk_cd: tmpkiykCd}).then(res => {
        const status = res.data.status

        if (status) {
          // 初期画面へ遷移
          this.$router.push('/initial')
          this.$store.dispatch('appSetting/tLogin')
        }
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        alert(this.connectionErrMsg)
      })
    }
  },
  computed: {
    // スマホサイズかどうか調べる
    breakpoint () {
      var phoneFlg = false
      const breakpoint = this.$vuetify.breakpoint.name
      switch (breakpoint) {
        case 'xs':
          phoneFlg = true
          break
        case 'sm':
          phoneFlg = true
          break
        case 'md':
          phoneFlg = false
          break
        case 'lg':
          phoneFlg = false
          break
        case 'xl':
          phoneFlg = false
          break
        default:
          phoneFlg = false
      }
      return phoneFlg
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/templates/KiykskSntk.vue